import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { QuestProvider } from '@questlabs/react-sdk';
import '@questlabs/react-sdk/dist/style.css';

import { AuthProvider } from './contexts/AuthContext';
import { EventProvider } from './contexts/EventContext';
import { RepresentativeProvider } from './contexts/RepresentativeContext';

import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import AppHelp from './components/help/HelpHub';
import questConfig from './config/questConfig';

import Home from './pages/Home';
import Learning from './pages/Learning';
import Events from './pages/Events';
import EventsAggregated from './pages/EventsAggregated';
import Candidates from './pages/Candidates';
import Community from './pages/Community';
import Representatives from './pages/Representatives';
import RepresentativesLookup from './pages/RepresentativesLookup';
import Resources from './pages/Resources';
import CandidateAdvertising from './pages/CandidateAdvertising';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminEventSources from './pages/AdminEventSources';
import RepublicanParty from './pages/RepublicanParty';

import './App.css';

function App() {
  return (
    <QuestProvider
      apiKey={questConfig.APIKEY}
      entityId={questConfig.ENTITYID}
      apiType="PRODUCTION"
    >
      <AuthProvider>
        <EventProvider>
          <RepresentativeProvider>
            <Router>
              <div className="min-h-screen bg-gray-50 flex flex-col">
                <Navbar />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/learning" element={<Learning />} />
                    <Route path="/learning/republican-party" element={<RepublicanParty />} />
                    <Route path="/events" element={<Events />} />
                    <Route path="/events/aggregated" element={<EventsAggregated />} />
                    <Route path="/candidates" element={<Candidates />} />
                    <Route path="/community" element={<Community />} />
                    <Route path="/representatives" element={<Representatives />} />
                    <Route path="/representatives/lookup" element={<RepresentativesLookup />} />
                    <Route path="/resources" element={<Resources />} />
                    <Route path="/advertise" element={<CandidateAdvertising />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/events/sources" element={<AdminEventSources />} />
                  </Routes>
                </main>
                <Footer />
                <AppHelp />
              </div>
            </Router>
          </RepresentativeProvider>
        </EventProvider>
      </AuthProvider>
    </QuestProvider>
  );
}

export default App;